module.exports = __webpack_public_path__ + "img/egg_hearts_happy.7fdf7e8a.svg";